export default "__VITE_ASSET__CP$CD2Tj__"